import { PremiumStatus } from "../../typings/common";
import { thor } from "../../typings/thor";

export class PremiumBtnController {
    public static $inject: string[] = ["$scope", "categoryService"];

    // binded
    public saleWithoutShipping: boolean;
    public isPast: boolean;
    public item: thor.ItemGet;
    public save: Function;

    public isDisabled: boolean;

    constructor($scope, private categoryService) {
        $scope.$watch(
            () => this.item,
            () => this.checkDisabled(),
            true
        );
        $scope.triggerCheckbox = () => {
            if (this.isDisabled) {
                return;
            }
            this.item.asked_for_premium = !this.item.asked_for_premium;
            this.save({ data: { asked_for_premium: this.item.asked_for_premium } });
        };
    }

    public $onInit() {
        this.checkDisabled();
    }

    public checkDisabled() {
        this.isDisabled = Boolean(
            !this.item ||
                (![PremiumStatus.Pending, PremiumStatus.Refused].includes(this.item.premium_status) &&
                    (!this.categoryService.checkPremiumCriteria(this.item) ||
                        (this.categoryService.isCategoryDeliverable(this.item) && this.saleWithoutShipping))) ||
                this.isPast
        );
    }
}
